<div
  #dropTarget
  class="drop-target"
  (dragenter)="dragOver($event)"
  (dragover)="dragOver($event)"
  (dragleave)="dragDone($event)"
  (drop)="filesDropped($event); dragDone($event)"
  [class]="'layout-' + layout"
>
  <ng-container *ngIf="layout !== 'button-only'">
    <mat-icon class="add-file-icon">library_add</mat-icon>
    <div class="text-container">
      <div class="drag-text" *ngIf="supportsDrag">
        <ng-container *ngIf="maxFiles === 1; else pluralBrowse">
          {{ descriptionText[0] | translate }}
        </ng-container>
        <ng-template #pluralBrowse>
          {{ descriptionText[1] | translate }}
        </ng-template>
      </div>
      <glxy-uploader-constraints-text
        [accept]="accept"
        [maxFiles]="maxFiles"
        [maxFileSize]="maxFileSize"
        [text]="hintText"
      />
    </div>
  </ng-container>

  <button class="browse-button" mat-stroked-button type="button" (click)="browseForFiles()">
    <ng-container *ngIf="maxFiles === 1; else pluralBrowse">
      {{ buttonText[0] | translate }}
    </ng-container>
    <ng-template #pluralBrowse>{{ buttonText[1] | translate }}</ng-template>
  </button>
</div>

<input
  #fileInput
  class="hidden-file-input"
  [attr.multiple]="!maxFiles || maxFiles > 1 ? '' : null"
  type="file"
  [accept]="accept"
  (change)="filesSelected($event)"
/>
